import React from 'react';

export const Drawer = ({ width = 75, height = 75, fill = 'currentColor' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 75 75"
        fill="none"
    >
        <g clipPath="url(#clip0_1111_8217)">
            <path
                d="M46.875 59.375H28.125V53.125H46.875V59.375ZM75 40.625V75H0L0.065625 39.9969L6.77188 7.35938C7.76562 3.0625 11.6094 0 15.9281 0H59.075C63.4812 0 67.2375 3 68.2188 7.29688L75 40.625ZM59.375 23.1562L61.9812 37.5H68.0406L62.1031 8.61875C61.9484 7.99501 61.6014 7.43576 61.1112 7.02017C60.621 6.60459 60.0125 6.35373 59.3719 6.30312L59.375 23.1562ZM21.8375 18.75H53.125V6.25H21.8687L21.8375 18.75ZM19.3687 37.5H55.6406L53.4031 25H21.6406L19.3687 37.5ZM6.95625 37.5H13.0156L15.625 23.1562V6.30625C14.3469 6.45 13.1687 7.425 12.875 8.69375L6.95625 37.5ZM68.75 43.75H6.25V68.75H68.75V43.75Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1111_8217">
                <rect width={width} height={height} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
